module.exports = {
  SocketServer: `//boyte.info`
  //SocketServer: `http://10.240.192.183:3006`
}